import React from 'react'
import { observer } from 'mobx-react'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'
import styles from './WorkpapersHeader.sass'
import {
  Dropdown,
  DropdownItem,
  DropdownItemTitle,
  DropdownTitle,
} from 'components/Dropdown'
import Button from 'components/Button'
import { getFeatureToggleClient } from 'infra/featureToggles'

interface Props {
  onMenuClick?: () => void
  onDownloadClick?: () => void
  onDrakeDownloadClick?: () => void
  completedCount: number
  totalCount: number
}

export default observer(function WorkpapersHeader({
  onMenuClick,
  onDownloadClick,
  onDrakeDownloadClick,
  completedCount,
  totalCount,
}: Props) {
  const showDrakeDownload = getFeatureToggleClient().variation(
    'WorkPortal.DrakeDownloadEnabled',
    false,
  )

  return (
    <div className={styles.mainHeader}>
      {onDownloadClick && (
        <IconButton onClick={onMenuClick} dataTest="workpaper-sidemenu-button">
          <Icon name="menu" size={26} />
        </IconButton>
      )}

      <div className={styles.mainHeaderTitle}>
        Work paper review
        <span className={styles.mainHeaderStatus}>
          {completedCount} of {totalCount} completed
        </span>
      </div>

      {(onDownloadClick || (onDrakeDownloadClick && showDrakeDownload)) && (
        <div className={styles.mainHeaderButtonBar}>
          <Dropdown
            autoDismiss
            position="bottom-end"
            button={
              <Button iconRight={<Icon name="dropdown" size={14} />}>
                Download
              </Button>
            }
          >
            <DropdownTitle>Download all as</DropdownTitle>

            {onDownloadClick && (
              <DropdownItem onClick={onDownloadClick}>
                <DropdownItemTitle>CSV</DropdownItemTitle>
              </DropdownItem>
            )}

            {onDrakeDownloadClick && showDrakeDownload && (
              <DropdownItem onClick={onDrakeDownloadClick}>
                <DropdownItemTitle>Drake file</DropdownItemTitle>
              </DropdownItem>
            )}
          </Dropdown>
        </div>
      )}
    </div>
  )
})
